import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { env } from "../../../env";
import axiosInstance from "../../globalInspector/axiosInstance";
import CommonToast from "../../../components/_utils/CommonToast";
import ICONS from "../../../assets/Icons";

const baseUrl = env.REACT_APP_BASE_URL;

export const beneLookUp = createAsyncThunk("beneLookUp", async (values) => {
  const { pan_number, page } = values ? values : { pan_number: null };

  try {
    const response = await axiosInstance.get(
      `${baseUrl}/accounts/beneficiary/lookup`,
      {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
        params: {
          pan: pan_number,
          page_no: page,
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
});

export const viewAccountDetail = createAsyncThunk(
  "viewAccountDetail",
  async (values) => {
    const { id } = values ? values : { id: null };
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/accounts/beneficiary/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
);

export const unachivedAccount = createAsyncThunk(
  "unachivedAccount",
  async (values, { rejectWithValue }) => {
    const { id } = values || { id: null };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/beneficiary/${id}/unarchive`,
        {}, // empty body, like your fetch
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error.message ||
        "Something went wrong while unarchiving the account.";

      // Optional toast
      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      return rejectWithValue({
        status: error?.response?.status || 500,
        message,
      });
    }
  },
);

export const achivedAccountPan = createAsyncThunk(
  "achivedAccountPan",
  async (values, { rejectWithValue }) => {
    try {
      const { id } = values ? values : { id: null };

      const response = await axiosInstance.put(
        `${baseUrl}/accounts/beneficiary/${id}/archive`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      if (response.status === 404) {
        return rejectWithValue(undefined);
      }

      if (response.status < 200 || response.status >= 300) {
        return rejectWithValue(response.data || "Unexpected error");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);
export const unachivedAccountPan = createAsyncThunk(
  "unachivedAccountPan",
  async (values, { rejectWithValue }) => {
    const { id } = values || { id: null };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/beneficiary/${id}/unarchive`,
        {}, // empty body same as fetch
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error.message ||
        "Something went wrong while unarchiving the account.";

      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      return rejectWithValue({
        status: error?.response?.status || 500,
        message,
      });
    }
  },
);

export const achivedAccountDetail = createAsyncThunk(
  "achivedAccountDetail",
  async ({ id, Navigate }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("q2p_token");

      const response = await axiosInstance.put(
        `${baseUrl}/accounts/beneficiary/${id}/archive`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": token,
          },
        },
      );

      return response.data;
    } catch (error) {
      if (error?.response?.data?.errors?.user_unauthorized) {
        Navigate("/feature_not_assigned", {
          state: {
            unavailableService: "BAAccountArchive",
          },
        });
        return;
      }

      if (
        error?.response?.data?.errors?.reimbursement_account ||
        error?.response?.data?.errors?.beneficiary_account
      ) {
        let errorMessage =
          error?.response?.data?.errors?.reimbursement_account?.[0] ||
          error?.response?.data?.errors?.beneficiary_account?.[0];
        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else if (
        error?.response?.data?.errors?.bank_account_number ||
        error?.response?.data?.errors?.permanent_account_number
      ) {
        let errorMessage =
          error?.response?.data?.errors?.bank_account_number[0] ||
          error?.response?.data?.errors?.permanent_account_number[0];
        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }

      let errorMessage =
        error?.response?.data?.errors?.bank_account_number[0] ||
        error?.response?.data?.errors?.beneficiary_account?.[0] ||
        error?.response?.data?.errors?.permanent_account_number[0] ||
        error?.response?.data?.errors[0]?.gstin_detail?.base ||
        error?.response?.data?.errors?.base[0];
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(errorMessage);
    }
  },
);
export const unachivedAccountDetail = createAsyncThunk(
  "unachivedAccountDetail",
  async ({ id, Navigate }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("q2p_token");

      const response = await axiosInstance.put(
        `${baseUrl}/accounts/beneficiary/${id}/unarchive`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": token,
          },
        },
      );
      return response.data;
    } catch (error) {
      if (error?.response?.data?.errors?.user_unauthorized) {
        Navigate("/feature_not_assigned", {
          state: {
            unavailableService: "BAAccountArchive",
          },
        });
        return;
      }
      const errData = error?.response?.data?.errors;

      if (!errData.base) {
        errData.beneficiary_account.forEach((error3) => {
          if (error?.response?.data.status === false) {
            setTimeout(() => {
              CommonToast({
                text: error3,
                icon: ICONS?.ERROR_WHITE_CIRCLE,
                variant: "var(--error)",
                buttonNeeded: false,
              });
            }, 1000);
          }
        });
      } else {
        CommonToast({
          text: errData.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }

      return rejectWithValue(errData);
    }
  },
);

export const achivedAccount = createAsyncThunk(
  "achivedAccount",
  async (values, { rejectWithValue }) => {
    const { id } = values || {};

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/beneficiary/${id}/archive`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      const errResponse = error?.response?.data || {
        status: false,
        message: error.message || "Something went wrong",
      };

      // Optional: toast display for debugging or alert
      if (errResponse?.error || errResponse?.message) {
        CommonToast({
          text: errResponse.error || errResponse.message,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }

      return rejectWithValue(errResponse);
    }
  },
);

export const verifyThisPAN = createAsyncThunk(
  "verifyThisPAN",
  async (values) => {
    const {
      pan_number,
      navigate,
      signal,
      showToast = true,
    } = values || {
      pan_number: null,
    };
    const searchString = pan_number || values?.search_string;

    try {
      const response = await axiosInstance.post(
        `${baseUrl}/verification/pan/verify`,
        { pan: searchString },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          signal,
        },
      );

      return response.data;
    } catch (error) {
      if (error?.name === "CanceledError" || error?.code === "ERR_CANCELED") {
        throw error;
      }
      if (error?.response?.data?.errors) {
        if (error?.response?.data?.errors?.user_unauthorized) {
          navigate("/feature_not_assigned", {
            state: {
              unavailableService: "BUAccount",
            },
          });
        } else {
          if (showToast)
            CommonToast({
              text: error.response?.data?.error,
              icon: ICONS?.ERROR_WHITE_CIRCLE,
              variant: "var(--error)",
              buttonNeeded: false,
            });
        }
      }
      return error?.response?.data;
    }
  },
);

export const verifyThisPANGet = createAsyncThunk(
  "verifyThisPANGet",
  async (values, { rejectWithValue }) => {
    const { pan_number } = values ? values : { pan_number: null };
    const token = sessionStorage.getItem("q2p_token");
    const pan = pan_number || values?.search_string;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/verification/pan/${pan}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": token,
            // try {
            //   const response = await axiosInstance.post(
            //     `${baseUrl}/verification/pan/verify`,
            //     {
            //       pan: values?.search_string,
            //     },
            //     {
            //       headers: {
            //         "Content-Type": "application/json",
            //         "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.errors?.base[0] ||
        error.response?.data?.message ||
        error.message;
      // CommonToast({
      //   text: errorMessage,
      //   icon: ICONS?.ERROR_WHITE_CIRCLE,
      //   variant: "var(--error)",
      //   buttonNeeded: false,
      // });
      return rejectWithValue(errorMessage);
    }
  },
);

export const verifyThisPANPost = createAsyncThunk(
  "verifyThisPANPost",
  async (values, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${baseUrl}/verification/pan/verify`,
        {
          pan: values?.search_string,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.errors?.base[0] ||
        error.response?.data?.message ||
        error.message;
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(errorMessage);
    }
  },
);

export const verifyThisBank = createAsyncThunk(
  "verifyThisBank",
  async (values, { rejectWithValue }) => {
    try {
      const { bank_acc_no, ifsc_code } = values
        ? values
        : { bank_acc_no: null, ifsc_code: null };

      const payload = {
        bank_acc_no,
        ifsc_code,
      };

      const response = await axiosInstance.post(
        `${baseUrl}/accounts/verify`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      if (response.status === 404) {
        return rejectWithValue(undefined);
      }

      if (response.status < 200 || response.status >= 300) {
        return rejectWithValue(response.data || "Unexpected error");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const verifyThisCIN = createAsyncThunk(
  "verifyThisCIN",
  async (values, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${baseUrl}/verification/cin/verify`,
        {
          cin: values?.search_string,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.errors?.base[0] ||
        error.response?.data?.message ||
        error.message;
      !(values?.showToast ?? true) &&
        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const verifyCINGet = createAsyncThunk(
  "verifyCINGet",
  async (values, { rejectWithValue }) => {
    const { cin_number } = values ? values : { cin_number: null };
    const token = sessionStorage.getItem("q2p_token");
    const cin = cin_number || values?.search_string;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/verification/cin/${cin}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": token,
            // try {
            //   const response = await axiosInstance.post(
            //     `${baseUrl}/verification/pan/verify`,
            //     {
            //       pan: values?.search_string,
            //     },
            //     {
            //       headers: {
            //         "Content-Type": "application/json",
            //         "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.errors?.base[0] ||
        error.response?.data?.message ||
        error.message;
      // CommonToast({
      //   text: errorMessage,
      //   icon: ICONS?.ERROR_WHITE_CIRCLE,
      //   variant: "var(--error)",
      //   buttonNeeded: false,
      // });
      return rejectWithValue(errorMessage);
    }
  },
);

export const verifyThisDIN = createAsyncThunk(
  "verifyThisDIN",
  async (values, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${baseUrl}/verification/din/verify`,
        {
          din: values?.search_string,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.errors?.base[0] ||
        error.response?.data?.message ||
        error.message;
      !(values?.showToast ?? true) &&
        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const verifyDINGet = createAsyncThunk(
  "verifyDINGet",
  async (values, { rejectWithValue }) => {
    const { din_number } = values ? values : { din_number: null };
    const token = sessionStorage.getItem("q2p_token");
    const din = din_number || values?.search_string;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/verification/din/${din}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": token,
            // try {
            //   const response = await axiosInstance.post(
            //     `${baseUrl}/verification/pan/verify`,
            //     {
            //       pan: values?.search_string,
            //     },
            //     {
            //       headers: {
            //         "Content-Type": "application/json",
            //         "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.errors?.base[0] ||
        error.response?.data?.message ||
        error.message;

      return rejectWithValue(errorMessage);
    }
  },
);

const verify = createSlice({
  name: "verify",
  initialState: {
    isCreateAcc: false,
    verifyPAN: null,
    verifyBank: null,
    isError: null,
    verifyCIN: null,
    verifyCinError: null,
    verifyCINisLoading: null,
    verifyDIN: null,
    verifyDINisLoading: null,
    verifyDINError: null,
    verifyGST: null,
    verifyPAN_New: null,
    verifyIFSC: null,
    beneLookData: null,
    beneLookLoading: null,
    beneLookError: null,
    verifyPANisLoading: null,
    verifyPANisError: null,
    unachivedData: null,
    unachivedLoading: null,
    unachivedError: null,
    achivedData: null,
    achivedLoading: null,
    achivedError: null,
    viewAccountDetailData: null,
    viewAccountDetailLoading: null,
    viewAccountDetailError: null,
    unachivedDataPan: null,
    unachivedLoadingPan: null,
    unachivedErrorPan: null,
    achivedDataPan: null,
    achivedLoadingPan: null,
    achivedErrorPan: null,
    unachivedDataDetail: null,
    unachivedLoadingDetail: null,
    unachivedErrorDetail: null,
    achivedDataDetail: null,
    achivedLoadingDetail: null,
    achivedErrorDetail: null,
    getVerifyPanData: null,
    getVerifyPanLoading: null,
    getVerifyPanError: null,
    getVerifyCinData: null,
    getVerifyCinLoading: null,
    getVerifyCinError: null,
    getVerifyDinData: null,
    getVerifyDinLoading: null,
    getVerifyDinError: null,
    selectedCinData: null,
    selectedDinData: null,
    selectedPanData: null,
    selectedGstData: null,
    resetSelectedPan: null,
  },
  reducers: {
    resetVerification(state) {
      state.verifyPAN = null;
      state.verifyBank = null;
    },
    setIsCreateAcc: (state, action) => {
      // state.isCreateAcc = action.payload;
      state.isCreateAcc = action.payload;
    },
    resetBeneData(state) {
      state.beneLookData = null;
    },
    resetIsCreateAcc: (state) => {
      state.isCreateAcc = false;
    },

    resetPANVerification(state) {
      state.verifyPAN = null;
    },
    resetBankVerification(state) {
      state.verifyBank = null;
    },
    resetPanArchived(state) {
      state.achivedDataPan = null;
    },
    resetPanUnarchived(state) {
      state.unachivedDataPan = null;
    },
    resetDetailachived(state) {
      state.achivedDataDetail = null;
    },
    resetDetailUnachived(state) {
      state.unachivedDataDetail = null;
    },
    resetInEdit(state) {
      state.verifyPAN = null;
      state.beneLookData = null;
      state.viewAccountDetailData = null;
      state.beneLookError = null;
    },
    resetAchivedAccount(state) {
      state.achivedData = null;
      state.achivedLoading = null;
    },
    resetUnAchivedAccount(state) {
      state.unachivedData = null;
      state.unachivedLoading = null;
    },

    resetGetPanData(state) {
      state.getVerifyPanData = null;
      state.getVerifyPanError = null;
      state.getVerifyPanLoading = null;
    },
    resetGetCinData(state) {
      state.getVerifyCinData = null;
      state.getVerifyCinError = null;
      state.getVerifyCinLoading = null;
    },
    resetGetCinError(state) {
      state.getVerifyCinData = null;
      state.getVerifyCinError = true;
    },
    resetGetDinData(state) {
      state.getVerifyDinData = null;
      state.getVerifyDinLoading = null;
      state.getVerifyDinError = null;
    },
    resetGetDinError(state) {
      state.getVerifyDinData = null;
      state.getVerifyDinError = true;
    },
    resetGetPanError(state) {
      state.getVerifyPanData = null;
      state.getVerifyPanError = true;
    },
    selectedCin(state, action) {
      state.selectedCinData = action.payload;
    },
    selectedDin(state, action) {
      state.selectedDinData = action.payload;
    },
    selectedPan(state, action) {
      state.selectedPanData = action.payload;
    },
    selectedGst(state, action) {
      state.selectedGstData = action.payload;
    },
    resetSelectedPan(state) {
      state.selectedPanData = null;
    },
    resetSelectedGst(state) {
      state.selectedGstData = null;
    },
    resetSelectedCin(state) {
      state.selectedCinData = null;
    },
    resetSelectedDin(state) {
      state.selectedDinData = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(viewAccountDetail.pending, (state, action) => {
      state.viewAccountDetailLoading = true;
    });
    builder.addCase(viewAccountDetail.fulfilled, (state, action) => {
      state.viewAccountDetailLoading = false;
      state.viewAccountDetailData = action.payload;
    });
    builder.addCase(viewAccountDetail.rejected, (state, action) => {
      state.viewAccountDetailError = true;
      state.viewAccountDetailData = null;
    });
    builder.addCase(beneLookUp.pending, (state, action) => {
      state.beneLookLoading = true;
      state.beneLookError = false;
    });
    builder.addCase(beneLookUp.fulfilled, (state, action) => {
      state.beneLookLoading = false;
      state.beneLookData = action.payload;
    });
    builder.addCase(beneLookUp.rejected, (state, action) => {
      state.beneLookError = true;
      state.beneLookLoading = false;
      state.beneLookData = null;
    });
    builder.addCase(unachivedAccount.pending, (state, action) => {
      state.unachivedLoading = true;
    });
    builder.addCase(unachivedAccount.fulfilled, (state, action) => {
      state.unachivedLoading = false;
      state.unachivedData = action.payload;
    });
    builder.addCase(unachivedAccount.rejected, (state, action) => {
      state.unachivedError = true;
    });
    builder.addCase(achivedAccount.pending, (state, action) => {
      state.achivedLoading = true;
    });
    builder.addCase(achivedAccount.fulfilled, (state, action) => {
      state.achivedLoading = false;
      state.achivedData = action.payload;
    });
    builder.addCase(achivedAccount.rejected, (state, action) => {
      state.achivedError = true;
    });
    builder.addCase(unachivedAccountPan.pending, (state, action) => {
      state.unachivedLoadingPan = true;
    });
    builder.addCase(unachivedAccountPan.fulfilled, (state, action) => {
      state.unachivedLoadingPan = false;
      state.unachivedDataPan = action.payload;
    });
    builder.addCase(unachivedAccountPan.rejected, (state, action) => {
      state.unachivedErrorPan = true;
    });
    builder.addCase(achivedAccountPan.pending, (state, action) => {
      state.achivedLoadingPan = true;
    });
    builder.addCase(achivedAccountPan.fulfilled, (state, action) => {
      state.achivedLoadingPan = false;
      state.achivedDataPan = action.payload;
    });
    builder.addCase(achivedAccountPan.rejected, (state, action) => {
      state.achivedErrorPan = true;
    });
    builder.addCase(verifyThisPAN.pending, (state, action) => {
      state.verifyPANisLoading = true;
    });
    builder.addCase(verifyThisPAN.fulfilled, (state, action) => {
      state.verifyPANisLoading = false;
      state.verifyPANisError = false;
      state.verifyPAN = action.payload;
    });
    builder.addCase(verifyThisPAN.rejected, (state, action) => {
      state.verifyPANisError = true;
      state.verifyPAN = null;
      state.verifyPANisLoading = false;
    });
    builder.addCase(verifyThisPANGet.pending, (state, action) => {
      state.getVerifyPanLoading = true;
    });
    builder.addCase(verifyThisPANGet.fulfilled, (state, action) => {
      state.getVerifyPanLoading = false;
      state.getVerifyPanError = false;
      state.getVerifyPanData = action.payload;
    });
    builder.addCase(verifyThisPANGet.rejected, (state, action) => {
      state.getVerifyPanError = true;
      state.getVerifyPanData = null;
      state.getVerifyPanLoading = false;
    });
    builder.addCase(verifyThisBank.pending, (state, action) => {
      state.verifyBankisLoading = true;
    });
    builder.addCase(verifyThisBank.fulfilled, (state, action) => {
      state.verifyBankisLoading = false;
      state.verifyBank = action.payload;
    });
    builder.addCase(verifyThisBank.rejected, (state, action) => {
      state.isError = true;
    });
    builder.addCase(verifyThisCIN.pending, (state, action) => {
      state.verifyCINisLoading = true;
    });
    builder.addCase(verifyThisCIN.fulfilled, (state, action) => {
      state.verifyCINisLoading = false;
      state.verifyCinError = false;
      state.verifyCIN = action.payload;
    });
    builder.addCase(verifyThisCIN.rejected, (state, action) => {
      state.verifyCinError = true;
      state.verifyCIN = null;
      state.verifyCINisLoading = false;
    });
    builder.addCase(verifyCINGet.pending, (state, action) => {
      state.getVerifyCinLoading = true;
    });
    builder.addCase(verifyCINGet.fulfilled, (state, action) => {
      state.getVerifyCinLoading = false;
      state.getVerifyCinError = false;
      state.getVerifyCinData = action.payload;
    });
    builder.addCase(verifyCINGet.rejected, (state, action) => {
      state.getVerifyCinError = true;
      state.getVerifyCinData = null;
      state.getVerifyCinLoading = false;
    });
    builder.addCase(verifyThisDIN.pending, (state, action) => {
      state.verifyDINisLoading = true;
    });
    builder.addCase(verifyThisDIN.fulfilled, (state, action) => {
      state.verifyDINError = null;
      state.verifyDINisLoading = false;
      state.verifyDIN = action.payload;
    });
    builder.addCase(verifyThisDIN.rejected, (state, action) => {
      state.verifyDINError = true;
      state.verifyDINisLoading = false;
      state.verifyDIN = null;
    });
    builder.addCase(verifyDINGet.pending, (state, action) => {
      state.getVerifyDinLoading = true;
    });
    builder.addCase(verifyDINGet.fulfilled, (state, action) => {
      state.getVerifyDinError = null;
      state.getVerifyDinLoading = false;
      state.getVerifyDinData = action.payload;
    });
    builder.addCase(verifyDINGet.rejected, (state, action) => {
      state.getVerifyDinError = true;
      state.getVerifyDinLoading = false;
      state.getVerifyDinData = null;
    });

    builder.addCase(unachivedAccountDetail.pending, (state, action) => {
      state.unachivedLoadingDetail = true;
    });
    builder.addCase(unachivedAccountDetail.fulfilled, (state, action) => {
      if (action.payload !== undefined) {
        CommonToast({
          text: "Account unarchived successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
      state.unachivedLoadingDetail = false;
      state.unachivedDataDetail = action.payload;
    });
    builder.addCase(unachivedAccountDetail.rejected, (state, action) => {
      state.unachivedErrorDetail = true;
    });
    builder.addCase(achivedAccountDetail.pending, (state, action) => {
      state.achivedLoadingDetail = true;
    });
    builder.addCase(achivedAccountDetail.fulfilled, (state, action) => {
      if (action.payload !== undefined) {
        CommonToast({
          text: "Account archived successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
      state.achivedLoadingDetail = false;
      state.achivedDataDetail = action.payload;
    });
    builder.addCase(achivedAccountDetail.rejected, (state, action) => {
      state.achivedErrorDetail = true;
    });
  },
});

export const {
  resetIsCreateAcc,
  setIsCreateAcc,
  resetVerification,
  resetPANVerification,
  resetBankVerification,
  resetBeneData,
  resetPanArchived,
  resetPanUnarchived,
  resetDetailUnachived,
  resetDetailachived,
  resetAchivedAccount,
  resetUnAchivedAccount,
  resetInEdit,
  resetGetPanData,
  resetGetCinData,
  resetGetDinData,
  resetSelectedCin,
  resetSelectedDin,
  selectedCin,
  selectedDin,
  selectedPan,
  resetSelectedPan,
  resetGetCinError,
  resetGetDinError,
  resetGetPanError,
  selectedGst,
  beneLookData,
  resetSelectedGst,
} = verify.actions;

export default verify.reducer;
